// src/components/Navbar.js
import React from 'react'; 
import { Link, useNavigate } from 'react-router-dom';
import { getAuth, signOut } from 'firebase/auth';
import { useAuth } from '../context/AuthContext';

function Navbar() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const ADMIN_UID = '3N1QaQpLuRfJXNPUypBXBE61V3F3';

  const handleLogout = async () => {
    const auth = getAuth();
    await signOut(auth);
    navigate('/login');
  };

  return (
    <nav
      role="navigation"
      className="bg-[#111] text-white px-4 py-3 shadow-md flex flex-col items-center"
    >
      {/* Lenker – mobilvennlig */}
      <div className="flex flex-wrap justify-center gap-3 text-sm md:text-base mb-2 w-full max-w-screen-sm">
        <Link to="/" className="hover:underline text-blue-400">Start</Link>
        <Link to="/all" className="hover:underline text-blue-400">Alle</Link>
        <Link to="/myessence" className="hover:underline text-blue-400">Min Essens</Link>
        <Link to="/notes" className="hover:underline text-blue-400">Notater</Link>
        <Link to="/chat" className="hover:underline text-blue-400">Chat</Link> {/* 👈 Ny lenke */}
        {user?.uid === ADMIN_UID && (
          <Link to="/admin" className="hover:underline text-yellow-300 font-semibold">👑 Admin</Link>
        )}
      </div>

      {/* Admin-status og logg ut – vises bare hvis admin er innlogget */}
      {user?.uid === ADMIN_UID && (
        <div className="absolute right-4 top-4 flex items-center space-x-4">
          <span className="text-xs text-gray-400">Admin-modus aktivert</span>
          <button
            onClick={handleLogout}
            className="text-xs bg-red-600 hover:bg-red-700 px-3 py-1 rounded"
          >
            Logg ut
          </button>
        </div>
      )}
    </nav>
  );
}

export default Navbar;